var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16C9.75 15.5858 9.41421 15.25 9 15.25C8.58579 15.25 8.25 15.5858 8.25 16H9.75ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM13 2.75H18V1.25H13V2.75ZM21.25 6V18H22.75V6H21.25ZM18 21.25H13V22.75H18V21.25ZM9.75 18V16H8.25V18H9.75ZM9.75 8V6H8.25V8H9.75ZM13 21.25C11.2051 21.25 9.75 19.7949 9.75 18H8.25C8.25 20.6234 10.3766 22.75 13 22.75V21.25ZM21.25 18C21.25 19.7949 19.7949 21.25 18 21.25V22.75C20.6234 22.75 22.75 20.6234 22.75 18H21.25ZM18 2.75C19.7949 2.75 21.25 4.20507 21.25 6H22.75C22.75 3.37665 20.6234 1.25 18 1.25V2.75ZM13 1.25C10.3766 1.25 8.25 3.37665 8.25 6H9.75C9.75 4.20507 11.2051 2.75 13 2.75V1.25Z",
    fill: "current",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15L16.2929 12.7071C16.6834 12.3166 16.6834 11.6834 16.2929 11.2929L14 9",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12L4 12",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login.cfc72f5ad4651fa9e3d79f959c321428.svg";